import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';
import SpecLink from 'src/components/SpecLink';

function PaymentRequestPage() {
    return <Page header='Payment request'>
        <p>
            Payment requests are used to prompt your customers to perform a particular action. Depending on merchant configuration, an email and SMS message can be sent to the customer. 
            Links will only be sent via email as SMS's contain notifications only.  Due dates and expiry dates can also be set. A Due date is when the action should be fulfilled by the 
            customer and an Expiry date is the date the Payment Request will no longer be accessible.
        </p>

        <h2>Actions</h2>
        <Table
            headers={['Action', 'Description']}
            body={[
                [<code>PayOnly</code>, 'Prompt a customer to make a payment for a specified amount.'],
                [<code>PreAuthOnly</code>, 'Prompt a customer to make a pre-auth transaction. A pre-auth transaction is authorisation only transaction that reserves the funds against the card. Funds are not debited until a corresponding Capture is approved.'],
                [<code>PayAndTokenise</code>, 'Prompt a customer to make a payment for a specified amount, the payment method will then be tokenised and stored for use later.'],
                [<code>PreAuthAndTokenise</code>, 'Prompt a customer to make a pre-auth transaction, the payment method will then be tokenised and stored for use later.'],
                [<code>TokeniseOnly</code>, 'Prompt a customer to enter their payment method details which will then be tokenised and stored for use later.'],
                [<code>UpdateToken</code>, 'Prompt a customer to enter payment method details which will be used to update an existing tokenised payment method.'],
                [<code>PayAndUpdateToken</code>, 'Prompt a customer to make a payment for a specified amount and then update an existing tokenise payment method.'],
                [<code>PreAuthAndUpdateToken</code>, 'Prompt a customer to make a pre-auth transaction and update an existing tokenised payment method.'],
            ]}
        />

        <h2>Acceptable Payment Types</h2>
        <Table
            headers={['Acceptable Payment Type', 'Description']}
            body={[
                [<code>SingleFull</code>, 'Customer can only make one full payment – Partial payments are not accepted.'],
                [<code>MultipleCapped</code>, 'Customer can make multiple partial payments capped to the amount. The total of the partial payments will not exceed the amount on the request.'],
                [<code>SingleAny</code>, 'Customer can make one payment of any amount.'],
            ]}
        />

        <h2>Messaging Modes</h2>
        <Table
            headers={['Acceptable Payment Type', 'Description']}
            body={[
                [<code>Gateway</code>, 'The payment request message will be delivered by Linkly.'],
                [<code>Merchant</code>, 'The payment request message will be delivered by the merchant'],
            ]}
        />

        <h2>Operations</h2>
        <Table
            headers={['Operation', 'Description']}
            body={[
                [<SpecLink uriFragment="#operation/PaymentRequest_UpdatePaymentRequest">Update</SpecLink>, 'Update a payment request.'],
                [<SpecLink uriFragment="#operation/PaymentRequest_CancelPaymentRequest">Cancel</SpecLink>, 'Cancel a payment request.'],
                [<SpecLink uriFragment="#operation/PaymentRequest_CreatePaymentRequest">Create</SpecLink>, 'Create a payment request.'],
                [<SpecLink uriFragment="#operation/PaymentRequest_SearchPaymentRequest">Search</SpecLink>, 'Search a payment request.'],
                [<SpecLink uriFragment="#operation/PaymentRequest_ResendPaymentRequest">Resend</SpecLink>, 'Resend a payment request.'],
            ]}
        />
    </Page>
}

export default PaymentRequestPage;
